import { useStaticQuery, graphql } from 'gatsby';

const Query = () => {
  const data = useStaticQuery(graphql`
    query {
      allContentfulCustomerStory {
        edges {
          node {
            id
            customer {
              ...User
            }
          }
        }
      }
    }
  `)
  return data
}

export default Query
